import React from "react";
import {Container} from "reactstrap";
import {inject, observer} from "mobx-react";
import GenericTableAffichage from "../../../components/Akitatek/Table/GenericTableAffichage";


const Devis = (inject("rootStore")(observer(class Devis extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.injected.rootStore.savedDatasStore.setHeader("Gestion des devis", "Ajouter / modifier / convertir un devis", "devis.jpg", this.injected.rootStore.devisStore)
    }

    get injected() {
        return this.props;
    }


    render() {
        return (
            <>
                <Container className="mt-2" fluid>
                    <GenericTableAffichage api={this.injected.rootStore.devisStore}
                                           user={false}
                                           status={true}
                                           filters={this.injected.rootStore.devisStore.defaultFilter}
                                           statusHeader={true}
                                           icon={<i className="fa fa-plus-circle mr-2" aria-hidden="true"/>}
                                           name={"Devis"}
                                           type="devis"/>

                </Container>
            </>
        );
    }
})));

export default Devis
